import {
    CanActivate,
    Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { RestClientService } from '@common/services/rest-client/rest-client.service';
import { SessionStorageService } from '@common/services/storage/session-storage.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private rest: RestClientService,
        private storage: SessionStorageService
    ) {}

    public canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        if (!this.rest.isAuthorized()) {
            this.router.navigate(['/catalog']).then(() => {});
            return false;
        }

        return true;
    }
}
